import { ChangeDetectionStrategy, Component, OnInit, signal, computed } from '@angular/core';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { StaffRoles } from 'src/app/auth/tokens';

@Component({
  selector: 'app-recruiting-dashboard',
  templateUrl: './recruiting-dashboard.component.html',
  styleUrls: ['./recruiting-dashboard.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruitingDashboardComponent implements OnInit {
  
    currentStaffId = signal<number>(0);

    dataPadOpenSplit = [66, 33];
    minDatapadSizes = [50, 0.2];
    splitterPanelSizes = signal<number[]>([99, 0.2]);
    
    // Role-based computed properties
    canEditSalesGoals = computed(() => {
        const user = this.auth.currentUser;
        return user ? (
            this.auth.hasAnyRole(['it', 'salesAdmin']) || 
            this.hasStaffId([106, 26, 21]) // Based on ColdFusion email restrictions
        ) : false;
    });
    
    canViewWebLeads = computed(() => {
        return this.auth.hasRole('salesAdmin');
    });
    
    canViewPromoCodes = computed(() => {
        return this.auth.hasRole('it');
    });
    
    canViewAdminStats = computed(() => {
        return this.auth.hasAnyRole(['admin', 'it', 'salesAdmin']);
    });
    
    canViewTeamStats = computed(() => {
        return this.auth.hasAnyRole(['admin', 'it', 'salesAdmin', 'sales']);
    });

    constructor(
        private auth: LocalAuthService
    ) {}

    ngOnInit() {
        this.currentStaffId.set(this.auth.currentUser?.newstaffId ?? 0);
    }

    dataPadCountChange(count: number) {
      if (count === 0) {
        this.splitterPanelSizes.set( [99, 1])
      }
      else {
        this.splitterPanelSizes.set(this.dataPadOpenSplit)
      }
    }
    
    // Role checking helper methods
    hasStaffId(staffIds: number[]): boolean {
        const user = this.auth.currentUser;
        return user ? staffIds.includes(user.newstaffId) : false;
    }
    
    hasEmail(emails: string[]): boolean {
        const user = this.auth.currentUser;
        return user ? emails.includes(user.email) : false;
    }

} 